module.exports = __webpack_public_path__ + "img/gem-light.729e979b.png";